import React from 'react';
import ApprovalLineSelectForm from '../../../components/techmng/approval/ApprovalLineSelectForm';

const TechApprovalFormContainer = ({ apprUuid, setApprUuid }) => {
  return <ApprovalLineSelectForm apprUuid={apprUuid} setApprUuid={setApprUuid} />;
};

export default TechApprovalFormContainer;
